import React from 'react';

export interface MemberProps {}

const Member: React.FC<MemberProps> = () => {
  return null;
};

export default Member;
